import { Injectable, inject } from '@angular/core';
import { UnitOfMeasurementValidator } from '@core/helpers/unit-of-measurement-validator';
import { first, Observable } from 'rxjs';
import { LoggerService } from '@shared/services/logger.service';
import { BluetoothService } from './bluetooth.service';

@Injectable({
  providedIn: 'root',
})
export class MeasurementUnitTypeService {
  #logger = inject(LoggerService);
  #bluetoothService = inject(BluetoothService);

  public onDataFrom38DLReceived(): Observable<string> {
    let valueString: string;
    return new Observable(observer => {
      this.#bluetoothService
        .onDataNotified()
        .pipe(first())
        .subscribe(data => {
          const decoder = new TextDecoder('utf-8');
          valueString = '' + decoder.decode(data);
          valueString = valueString.replace(/OK/g, '').replace(/\s/g, '').toLowerCase();
          this.#logger.info('Unit Of Measurement:' + valueString);
          if (UnitOfMeasurementValidator.validate(valueString)) {
            observer.next(valueString);
          } else {
            observer.next(null);
          }
        });
    });
  }
}
